import {
  CellParams,
  Column,
  defaultColActionDef,
  defaultColDef,
  formatter,
  TABLE_ACTION
} from '@qrios/frontend-library';

import { StatusMapper } from '../../../../../common/status';
import locales from '../../../../../../constants/commonLocales';
import { predefinedColumns } from '../../../../../common/table/columns/predefinedColumns';
import { creditTypesFormatter } from '../../../../../common/table/utils/creditTypesFormatter';

const ACTIONS = [TABLE_ACTION.INFO];

export const walletOperationStatusRenderer = (cell: CellParams) => <StatusMapper status={cell.value} />;

export const columns: Column[] = [
  {
    ...defaultColDef,
    field: 'id',
    headerName: 'Credit Id',
    flex: 1,
    minWidth: 150
  },
  {
    ...defaultColDef,
    field: 'status',
    headerName: locales.table.column.status,
    renderCell: walletOperationStatusRenderer,
    minWidth: 150,
    flex: 1
  },
  {
    ...defaultColDef,
    field: 'creditType',
    headerName: locales.table.column.creditType,
    valueFormatter: creditTypesFormatter,
    flex: 2
  },
  {
    ...defaultColDef,
    field: 'amount',
    headerName: locales.table.column.amount,
    flex: 1,
    valueFormatter: formatter.amountFormatter
  },
  predefinedColumns.orderDate({}),
  {
    ...defaultColActionDef(ACTIONS)
  }
];
